import React, { useState } from 'react';
import Modal from '@ff/ui/Modal';
import share from './icons/icon_share.svg';
import { Props as EventHeroImageProps } from './props-schema';
import Box from '@ff/ui/Box';
import { styled } from '@ff/ui';
import SocialIcon from './SocialIcon';
import Image from '@ff/ui/Image';

type Props = Pick<EventHeroImageProps, 'region' | 'socialLinks'>;

export default function ShareIcon(props: Props) {
  const { region = 'US', socialLinks } = props;

  const title = region === 'US' ? 'Share to' : '转发分享';

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Share src={share} alt="share" onClick={() => { setIsOpen(true); }} />
      <Modal open={isOpen} backdrop closeOnBackdrop onClose={() => { setIsOpen(false); }}>
        <Menu>
          <Header>
            {title}
            <img src={share} alt="share" />
          </Header>
          <IconGridContainer>
            {
              socialLinks?.icons.map(({ icon }) => (
                <SocialIcon
                  region={region}
                  key={icon}
                  icon={icon}
                  metadata={socialLinks?.metadata} />
              ))
            }
          </IconGridContainer>
        </Menu>
      </Modal>
    </>
  );
}

const Share = styled(Image)({
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
});

const Menu = styled(Box)<{ colorTheme?: string }>({
  fontFamily: 'Roboto',
  color: 'white',
});

const Header = styled(Box)({
  backgroundColor: 'black',
  display: 'flex',
  flexDirection: 'row',
  columnGap: '10px',
  justifyContent: 'center',
  padding: '19px 24px',
});

const IconGridContainer = styled(Box)({
  backgroundColor: '#3F3F43',
  padding: '29px 25px 25px 25px',
  display: 'grid',
  gridTemplateColumns: 'auto',
  columnGap: '16px',
  rowGap: '16px',
  '*:hover': {
    backgroundColor: '#646464',
  }
});
